import Vue from "vue";

Vue.prototype.$fondo = [
  { key: "high_heel_zep" },
  { key: "ext_high_heel" },
  { key: "ext_high_pla" },
  { key: "ext_high_poi" },
  { key: "spe_heel" },
  { key: "spe_poi" }
];
